export default {
      id: "export-docx-icon-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#export-docx-icon-usage",
      toString: function () {
        return this.url;
      }
    }